module.exports = __webpack_public_path__ + "img/info.007.f847ddd6.jpeg";